import { Feature } from "ol";
import { RealTimeTrafficAttributeValue } from "./RealTimeTrafficAttributeValue";
/**
 * ファイル出力用属性クラス
 */
export class ExportRealTimeValue {
  /**
   * JSON出力用Feature
   */
  feature: Feature;

  /**
   * 画面項目リスト
   */
  attributeValues: RealTimeTrafficAttributeValue[];
  attributeHeader: string[]
  /**
   * JSONファイル名
   */
  jsonFileName: string;

  /**
   * CSVファイル名
   */
  csvFileName: string;

  /**
   * @param feature 地物情報
   * @param attributeValues 属性表示値
   * @param jsonFileName JSON出力ファイル名
   * @param csvFileName CSV出力ファイル名
   */
  constructor(
    feature: Feature,
    attributeValues: RealTimeTrafficAttributeValue[],
    attributeHeader: string[],
    jsonFileName: string,
    csvFileName: string
  ) {
    this.feature = feature;
    this.attributeValues = attributeValues;
    this.attributeHeader = attributeHeader
    this.jsonFileName = jsonFileName;
    this.csvFileName = csvFileName;
  }
}
